<template>
  <div class="banner">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="logo">
            <img src="/static/img/logo.png">
          </div>
          <div class="banner-inner">
            <h1>Kým budeš dnes?</h1>
            <h2>Si <span class="green">dobrodruh</span>, <span class="pink-light">maškrtník</span>, <span class="yellow">hviezda každej párty</span> alebo <span class="blue-light">dnešok preleňošíš v posteli</span>?</h2>
            <div class="be-you-logo">
              <img src="/static/img/be-you-white-logo.png">
            </div>
            <p v-on:click="scroll"><font-awesome-icon :icon="faArrowDownIcon" style="margin-right: 10px"/><span>Urob si test a zisti, kým si dnes!</span></p>
          </div>
        </div>
      </div>
    </div>
    <Rainbow></Rainbow>
  </div>
</template>

<script>
import Rainbow from './Rainbow.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faArrowDown from '@fortawesome/fontawesome-free-solid/faArrowDown'
import VueScrollTo from 'vue-scrollto'

export default {
  computed: {
    faArrowDownIcon () {
      return faArrowDown
    }
  },
  components: {
    FontAwesomeIcon,
    Rainbow
  },
  methods: {
    scroll: function () {
      VueScrollTo.scrollTo('.choose')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .banner {
    background: $color-blue;
    text-align: center;
    color: $color-white;
    overflow: hidden;
    .logo {
      text-align: left;
      padding: 30px 0;
    }
    &-inner {
      padding: 90px 0 100px 0;
    }
    h1 {
      font-size: 60px;
      margin-bottom: 35px;
      font-weight: 700
    }
    h2 {
      font-size: 36px;
      font-weight: 500;
      line-height: 1.3;
      max-width: 710px;
      text-align: center;
      display: inline-block;
      margin-bottom: 55px;
      .green {
        color: $color-green;
      }
      .pink-light {
        color: $color-pink-light;
      }
      .yellow {
        color: $color-yellow;
      }
      .blue-light {
        color: $color-blue-light;
      }
    }
    .be-you-logo {
      margin-bottom: 60px;
    }
    p {
      font-size: 24px;
      margin-bottom: 0;
      cursor: pointer;
      &:hover {
        span {
          text-decoration: underline;
        }
      }
    }

    @media (max-width: $breakpoint-sm) {
      .logo {
        padding: 20px 0 0 0;
        img {
          width: 140px;
        }
      }
      &-inner {
        padding: 80px 0 60px 0;
      }
      h1 {
        font-size: 30px;
      }
      h2 {
        font-size: 24px;
      }
      .be-you-logo {
        img {
          width: 200px;
        }
      }
      p {
        font-size: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Banner.vue